import { createSelector } from 'reselect';
import get from 'lodash/get';

export const getCriteria = state => state.searchAndBrowse.criteria;

export const getCriteriaAlternative = createSelector([getCriteria], criteria =>
  get(criteria, 'alternative', false),
);

export const getCriteriaSearchTags = createSelector([getCriteria], criteria =>
  get(criteria, 'searchTags', []),
);

export const getCriteriaSearchTagsAsString = createSelector([getCriteriaSearchTags], searchTags =>
  searchTags
    .map(item => item.text)
    .join(' ')
    .trim(),
);

export const getCriteriaSuggestedSearchTags = createSelector([getCriteria], criteria =>
  get(criteria, 'suggestedSearchTags', []),
);
